import token, { tokenToVars } from '../token';
import Carousel from './carousel';

export { Carousel };
export default tokenToVars(Carousel, token);
